module.exports = __webpack_public_path__ + "img/Unit_Guide_cans.51a1f374.svg";